import React, { useState } from "react";
import { Download, Share, Plus, X } from "lucide-react";
import { usePWA } from "@/context/PWAContext";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { BRAND } from "@/config";

export const InstallButton = ({ className = "" }) => {
  const pwa = usePWA();
  const [iosOpen, setIosOpen] = useState(false);

  if (!pwa || !pwa.canInstall) return null;

  const handleClick = async () => {
    if (pwa.hasPrompt) {
      await pwa.install();
    } else if (pwa.isIOS) {
      setIosOpen(true);
    }
  };

  return (
    <>
      <Button
        data-testid="install-app-btn"
        onClick={handleClick}
        variant="outline"
        className={`rounded-full border-[#e2ff31]/60 bg-[#e2ff31]/10 text-[#e2ff31] hover:bg-[#e2ff31] hover:text-black font-semibold gap-2 ${className}`}
      >
        <Download className="w-4 h-4" />
        <span className="hidden sm:inline">Install App</span>
      </Button>

      <Dialog open={iosOpen} onOpenChange={setIosOpen}>
        <DialogContent data-testid="ios-install-dialog" className="bg-[#121212] border-[#2a2a2a] text-[#f3f4f6]">
          <DialogHeader>
            <DialogTitle className="font-heading">Install {BRAND}</DialogTitle>
            <DialogDescription className="text-[#9ca3af]">
              Add {BRAND} to your Home Screen for an app-like experience.
            </DialogDescription>
          </DialogHeader>
          <ol className="space-y-4 mt-2 text-sm">
            <li className="flex items-center gap-3">
              <span className="w-7 h-7 rounded-full bg-[#e2ff31] text-black flex items-center justify-center font-bold shrink-0">1</span>
              <span className="flex items-center gap-1.5">
                Tap the <Share className="w-4 h-4 inline text-[#e2ff31]" /> <b>Share</b> button in Safari
              </span>
            </li>
            <li className="flex items-center gap-3">
              <span className="w-7 h-7 rounded-full bg-[#e2ff31] text-black flex items-center justify-center font-bold shrink-0">2</span>
              <span className="flex items-center gap-1.5">
                Choose <Plus className="w-4 h-4 inline text-[#e2ff31]" /> <b>Add to Home Screen</b>
              </span>
            </li>
            <li className="flex items-center gap-3">
              <span className="w-7 h-7 rounded-full bg-[#e2ff31] text-black flex items-center justify-center font-bold shrink-0">3</span>
              <span>Tap <b>Add</b> — done!</span>
            </li>
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
};
